import { useEffect } from 'react';
import { syncLights } from '../../interface/';

const Lights = ({ lights }) => {
  useEffect(() => {
    if (lights) {
      syncLights(lights);
    }
  }, [lights]);

  return null;
};

export default Lights;
